import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { CreateCategory, UpdateCategory } from '../models/category.model';
import {
  CreateProductIdentifierType,
  UpdateProductIdentifierType,
} from '../models/product-identifier-type.model';

@Injectable({
  providedIn: 'root',
})
export class ProductIdentifierTypeService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(pageNumber: number, pageSize: number, name?: string) {
    let params = '';

    if (name) params += `&name=${name}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/product-identifier-types?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/product-identifier-types/' + id
    );
  }

  getAllDropdown(name?: string) {
    let params = '';

    if (name) {
      params += `?name=${name}`;
    }
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/product-identifier-types/dropdown${params}`
    );
  }

  create(data: CreateProductIdentifierType) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/product-identifier-types',
      data
    );
  }

  update(id: string, data: UpdateProductIdentifierType) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/product-identifier-types/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/product-identifier-types/${id}/status`,
      { isActive }
    );
  }
}
